import React from 'react';
import { connect } from 'react-redux';
import { Header, Button } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import ReactGA from 'react-ga';

import { RootContainer } from '../../../login';


const mapStateToProps = ({ intl }) => {
  return {
    locale: intl.locale,
  };
};

const style = {
  inverted: {
    color: '#fff',
  },
  header: {
    fontSize: '4rem',
  },
};

const handleClick = () => {
  ReactGA.event({
    category: 'Actions',
    action: 'Clicou em "Baixar PDF"',
  });
};

const pdf = 'https://admin.futurecom.com.br/uploads/layout/layout_2018.pdf';

const Home = props => (
  <RootContainer {...props}>
    <div style={style.inverted}>
      <Header inverted as="h1" style={style.header}>
        <FormattedMessage
          id="app.home.header"
        />
      </Header>
      <embed
        width="100%"
        height="600"
        src={pdf}
        type="application/pdf"
      />
      <br />
      <Button onClick={handleClick} as="a" href={pdf} color="red" download>
        <FormattedMessage
          id="app.actions.download"
        />
      </Button>
    </div>
  </RootContainer>
);

export default connect(mapStateToProps)(Home);



/** WEBPACK FOOTER **
 ** ./src/app/modules/floorplan/components/home/Home.js
 **/